import { Helmet } from 'react-helmet-async';

/**
 * Composant SEO réutilisable pour optimiser le référencement
 *
 * @param {Object} props
 * @param {string} props.title - Titre de la page
 * @param {string} props.description - Description de la page
 * @param {string} props.keywords - Mots-clés (optionnel)
 * @param {string} props.image - Image pour Open Graph (optionnel)
 * @param {string} props.url - URL canonique (optionnel)
 * @param {string} props.type - Type Open Graph (website, article, etc.) - défaut: "website"
 * @param {boolean} props.noindex - Si true, empêche l'indexation (défaut: false)
 */
const SEOHead = ({
  title,
  description,
  keywords,
  image = 'https://logiconnect-gn.com/og-image.png',
  url,
  type = 'website',
  noindex = false,
}) => {
  const siteUrl = 'https://logiconnect-gn.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  // Titre complet avec le nom du site
  const fullTitle = title ? `${title} | LogiConnect` : 'LogiConnect - Plateforme de Transport et Logistique en Guinée';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="LogiConnect" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:image:alt" content={fullTitle} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEOHead;
